// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._2rko1kw7{border-radius:inherit}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/renderer/node_modules/@atlaskit/link-datasource/dist/esm/ui/datasource-table-view/datasourceTableView.compiled.css"],"names":[],"mappings":"AAAA,WAAW,qBAAqB","sourcesContent":["._2rko1kw7{border-radius:inherit}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
